<template>
  <div v-if="upsellProducts && upsellProducts.length > 0">
    <h4>{{ upsellTitle }}</h4>
    <ul class="list-unstyled d-flex flex-wrap mb-0">
      <li
        v-for="product in upsellProducts"
        :key="'up-' + product.ProductID"
        class="w-100 mb-3"
        :class="isProductSoldout(product) ? 'sold-out-md' : ''"
      >
        <div
          class="custom-checkbox md-container d-flex justify-content-between"
          :class="{
            'custom-control': true,
            disabled: isProductSoldout(product),
          }"
        >
          <Checkbox
            style="width: 80%"
            :key="'uch-' + product.ProductID"
            :label="product.Name"
            :input-value="product"
            v-model="selectedProducts"
            :disabled="isProductSoldout(product)"
          ></Checkbox>
          <span class="mr-2">{{
            product.Price | formatMoney(currencySign)
          }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Checkbox from "../../shared/ArrayCheckbox";

export default {
  components: { Checkbox },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedProducts: [],
      upsellProducts: [],
      upsellTitle: "",
    };
  },
  mounted() {
    this.upsellTitle = this.$t("message.upsellTitle");
    if (this.storeMenu && this.upsellMenus[this.storeMenu.MenuID]) {
      const upsellCategories =
        this.upsellMenus[this.storeMenu.MenuID].Categories;
      if (upsellCategories && upsellCategories.length > 0) {
        const upsellCategory = upsellCategories.find(
          (ct) => ct.ID == this.category.ID
        );
        if (
          upsellCategory &&
          upsellCategory.Products &&
          upsellCategory.Products.length > 0
        ) {
          if (upsellCategory.UpsellName) {
            this.upsellTitle = upsellCategory.UpsellName;
          }
          let uProducts = upsellCategory.Products.map((p) => {
            return {
              ...this.storeMenu.Products[p.ProductID],
              ...this.categoryItems.find((ct) => ct.ProductID == p.ProductID),
            };
          });
          this.upsellProducts = uProducts.filter((up) => up);
        }
      }
    }
  },
  watch: {
    selectedProducts(newvalue) {
      this.$emit("onvalue", newvalue);
    },
  },
  computed: {
    ...mapGetters([
      "storeMenu",
      "upsellMenus",
      "currencySign",
      "productStatuses",
    ]),

    categoryItems() {
      let items = [];
      if (this.storeMenu) {
        items = this.storeMenu.Categories.flatMap((ct) => ct.SubMenuItems);
      }
      return items;
    },
  },
  methods: {
    isProductSoldout(product) {
      return this.productStatuses[product.ProductID] === 3;
    },
  },
};
</script>
